// extracted by mini-css-extract-plugin
export default {"subTotalContainer":"JUVA7TJ EVhxZk8 leavesden2"};